import type { ExitsInvestmentsToCompleteResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ExitsInvestmentsReviewGateway } from './exits-investments-review.gateway';

/**
 * Real implementation over the shared api client: the single place that knows
 * the queue's endpoint. Its rows come wrapped in a `{ data, total }` payload.
 */
export const httpExitsInvestmentsReviewGateway: ExitsInvestmentsReviewGateway = {
  loadExitsInvestmentsToCompleteProfiles: async (signal) => {
    const res = await api.get<ExitsInvestmentsToCompleteResponse>(
      '/exits-investments-to-complete-profiles',
      signal,
    );
    return res.data;
  },
};
